import { render, staticRenderFns } from "./Desarquivar.vue?vue&type=template&id=0458801a"
import script from "./Desarquivar.vue?vue&type=script&lang=js"
export * from "./Desarquivar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports